export const ServiceRequestsStates = {
  assignedServiceRequests: 'Asignadas',
  notAssignedServiceRequests: 'Sin asignar',
  notPublishedServiceRequests: 'No publicadas',
}
